import { render } from "./PhoneCallTab.vue?vue&type=template&id=cd22b130"
import script from "./PhoneCallTab.vue?vue&type=script&lang=js"
export * from "./PhoneCallTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__